import {Component, OnInit} from '@angular/core';
import { Router} from "@angular/router";
import {EventService} from '../../core/services/event.service';
import {NationalTeamsService} from '../../core/services/national-teams.service';
import {ProgressService} from '../../core/services/progress.service';
import {FundraisingViewService} from "../../core/services/fundraising-view.service";

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html'
})

export class MainComponent implements OnInit {

    constructor(private router: Router,
                private eventService: EventService,
                private nationalTeamsService: NationalTeamsService,
                private progressService: ProgressService,
                private fundraisingViewService: FundraisingViewService) {}

    ngOnInit() {
        const lastFundraisingToolsView = localStorage.getItem('org.lls.last-view');
        let lastViewEvents = false;
        let lastViewNationalTeams = false;
        if (!!lastFundraisingToolsView) {
            if (lastFundraisingToolsView === 'national-teams') {
                lastViewNationalTeams = true;
            } else {
                lastViewEvents = true;
            }
        }
        if (this.eventService.getAllEvents().length > 0 && this.nationalTeamsService.getAllNationalTeams().length > 0) {
            if (lastViewNationalTeams) {
                this.router.navigate(['/national/teams/' + this.nationalTeamsService.selectedNationalTeam.teamId]);
            } else if (lastViewEvents){
                this.router.navigate(['/home']);
            } else {
                this.router.navigate(['/home']);
                localStorage.setItem('org.lls.last-view', 'events');
            }
        } else if (this.eventService.getAllEvents().length > 0) {
            this.router.navigate(['/home']);
            localStorage.setItem('org.lls.last-view', 'events');
        } else if (this.nationalTeamsService.getAllNationalTeams().length > 0) {
            this.router.navigate(['/national/teams/' + this.nationalTeamsService.selectedNationalTeam.teamId]);
            localStorage.setItem('org.lls.last-view', 'national-teams');
        } else {
            this.router.navigate(['/unregistered']);
        }
        this.fundraisingViewService.onViewInit.emit();
        this.progressService.stopProgress(false);
    }
}

